import { makeStyles } from "@material-ui/core";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import clsx from "clsx";
import { ChangeEvent, FC, useState } from "react";

import { storageRef } from "../init/firebase";
import { GenericFunction } from "../types/generic.types";
import Loader from "./Loader";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.primary.main,
    cursor: "pointer",
    margin: theme.spacing(1),
  },
  input: {
    display: "none",
  },
  disabled: {
    pointerEvents: "none",
    opacity: 0.5,
  },
}));

const UploadFile: FC<UploadFileProps> = ({ onUpload, disabled = false }) => {
  const classes = useStyles({});
  const [loading, setLoading] = useState(false);

  const handleUpload = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
    const imageFiles = event.target.files;
    if (imageFiles && imageFiles.length > 0) {
      setLoading(true);
      const path = `chat/${new Date().getTime().toString()}`;
      const imageRef = storageRef.child(path);
      try {
        await imageRef.put(imageFiles[0]);
        const url = await imageRef.getDownloadURL();
        onUpload({
          path,
          src: url,
        });
      } catch (ex: any) {
        console.log(ex.message);
        onUpload(undefined);
      } finally {
        setLoading(false);
      }
    }
    onUpload(undefined);
  };

  return (
    <>
      <label htmlFor="upload-image">
        <Loader loading={loading}>
          <AddPhotoAlternateIcon className={clsx([classes.button, { [classes.disabled]: disabled }])} />
        </Loader>
      </label>
      <input accept="image/*" className={classes.input} id="upload-image" type="file" onChange={handleUpload} />
    </>
  );
};

interface UploadFileProps {
  onUpload: GenericFunction;
  disabled?: boolean;
}

export default UploadFile;
